var React = require('react');

function DataLoader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34 18C34 9.16344 26.8366 2 18 2M2 18C2 11.9759 5.32915 6.72946 10.248 4M18 34C16.7978 34 15.6265 33.8674 14.5 33.616M8.5 30.8757C6.14167 29.1328 4.27918 26.7574 3.16303 24","stroke":"#4B4B4D","strokeWidth":"4","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M2 18C2 11.9759 5.32915 6.72946 10.248 4","stroke":"#7F7F82","strokeWidth":"4","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M8.50005 30.8757C6.14173 29.1328 4.27924 26.7574 3.16309 24.0001","stroke":"#BDBDC1","strokeWidth":"4","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M18 34C16.7978 34 15.6265 33.8674 14.5 33.616","stroke":"#ECEDF0","strokeWidth":"4","strokeLinecap":"round","key":3})]);
}

DataLoader.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = DataLoader;

DataLoader.default = DataLoader;
